// Import model
import { StartLeadAppointmentInitiateSmsForUpcomingApppointmentRequest } from '../models/StartLeadAppointmentInitiateSmsForUpcomingApppointmentRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartLeadAppointmentInitiateSmsForUpcomingApppointmentRequest - handles JSON serialization and deserialization with type validation
 */
export class StartLeadAppointmentInitiateSmsForUpcomingApppointmentRequestSerializer {
  /**
   * Deserializes a JSON string into a StartLeadAppointmentInitiateSmsForUpcomingApppointmentRequest instance
   */
  static deserialize(json: string): StartLeadAppointmentInitiateSmsForUpcomingApppointmentRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartLeadAppointmentInitiateSmsForUpcomingApppointmentRequest instance
   */
  static fromObject(obj: any): StartLeadAppointmentInitiateSmsForUpcomingApppointmentRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartLeadAppointmentInitiateSmsForUpcomingApppointmentRequest');
    }


    const instance: StartLeadAppointmentInitiateSmsForUpcomingApppointmentRequest = {
      phoneNumber: obj['PhoneNumber'] as string | undefined,
      description: obj['Description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartLeadAppointmentInitiateSmsForUpcomingApppointmentRequest instances
   */
  static deserializeArray(json: string): StartLeadAppointmentInitiateSmsForUpcomingApppointmentRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartLeadAppointmentInitiateSmsForUpcomingApppointmentRequest instance to a JSON string
   */
  static serialize(instance: StartLeadAppointmentInitiateSmsForUpcomingApppointmentRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartLeadAppointmentInitiateSmsForUpcomingApppointmentRequest instance to a plain object
   */
  static toObject(instance: StartLeadAppointmentInitiateSmsForUpcomingApppointmentRequest): any {
    return {
      'PhoneNumber': instance.phoneNumber,
      'Description': instance.description,
    };
  }

  /**
   * Serializes an array of StartLeadAppointmentInitiateSmsForUpcomingApppointmentRequest instances to a JSON string
   */
  static serializeArray(instances: StartLeadAppointmentInitiateSmsForUpcomingApppointmentRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
